import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row w-100" }
const _hoisted_2 = { class: "card-body w-50" }
const _hoisted_3 = { class: "card-body w-50" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "pb-10 pb-lg-12" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Biological Sample")
], -1)
const _hoisted_5 = { class: "fv-row" }
const _hoisted_6 = { class: "d-flex flex-stack" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mb-6" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Will this research include blood drawing, marrow biopsy sampling, biopsy of other tissues, etc.")
], -1)
const _hoisted_8 = { class: "form-check form-switch form-check-custom form-check-solid mb-7" }
const _hoisted_9 = { class: "form-check-label fw-bold text-gray-400" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "d-flex flex-column mb-5 mt-5 fv-row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "State the amount (volume measure) and frequency in which the samples are taken. ", -1)
const _hoisted_13 = { class: "fv-row mb-10" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Describe how the biological samples will be collected, by who, and where the samples will be stored. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDownSection = _resolveComponent("DropDownSection")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_editor = _resolveComponent("editor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DropDownSection, {
        title: "Review for more information",
        list: _ctx.listDropDownSections
      }, null, 8, ["list"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("label", _hoisted_8, [
            _createVNode(_component_Field, {
              type: "checkbox",
              class: "form-check-input",
              name: "includeSomething",
              value: "1",
              modelValue: _ctx.step3.includeSomething,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step3.includeSomething) = $event))
            }, null, 8, ["modelValue"]),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.step3.includeSomething == "1" ? "Yes" : "No"), 1)
          ])
        ])
      ]),
      (_ctx.step3.includeSomething === '1')
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_Field, {
                class: "form-control form-control-solid mb-3",
                placeholder: "Volume",
                name: "volume",
                modelValue: _ctx.step3.volume,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.step3.volume) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "volume",
                class: "fv-plugins-message-container invalid-feedback"
              }),
              _createVNode(_component_Field, {
                class: "form-control form-control-solid",
                placeholder: "Frequency",
                name: "frequency",
                modelValue: _ctx.step3.frequency,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step3.frequency) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "frequency",
                class: "fv-plugins-message-container invalid-feedback"
              })
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_editor, {
                for: "sampleDescription",
                initialValue: "step3.sampleDescription",
                modelValue: _ctx.step3.sampleDescription,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.step3.sampleDescription) = $event)),
                "api-key": _ctx.currentEditorToken,
                licenseKey: "gpl",
                init: {
              height: 150,
              menubar: false,
              plugins: [
                'advlist autolink lists link image charmap',
                'searchreplace visualblocks code fullscreen',
                'print preview anchor insertdatetime media',
                'paste code help wordcount table',
              ],
              toolbar:
                'undo redo | formatselect | bold italic |         alignleft aligncenter alignright |         bullist numlist outdent indent | help',
            }
              }, null, 8, ["modelValue", "api-key"]),
              _createVNode(_component_Field, {
                type: "hidden",
                name: "sampleDescription",
                class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                placeholder: "How it will be record?",
                modelValue: _ctx.step3.sampleDescription,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.step3.sampleDescription) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "sampleDescription",
                class: "fv-plugins-message-container invalid-feedback"
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}